







































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Contacts extends Vue { 
    @Prop(Array) readonly projectLists: any
    @Prop() public changeState: any

	projectValue = null as any

	updateState () {
		if (this.projectValue !== null) {
			this.changeState("projectId", this.projectValue.map((x:any ) => x.id))
		}
		if (this.projectValue === null) {
			this.changeState("projectId", [])
		}
	}
}

